export const StepHeader = ({ step, total, label }) => (
  <div className="flex items-center gap-3 mb-8" data-testid="step-indicator">
    <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#4A6B56]/80">
      Step {step} of {total}
    </span>
    <span className="w-1 h-1 rounded-full bg-[#4A6B56]/40" />
    <span className="text-xs uppercase tracking-[0.25em] text-[#5F6A62]">{label}</span>
  </div>
);
